// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__9rE5e","dragIcon":"SortableItem_dragIcon__gjdsV","disabled":"SortableItem_disabled__2DHWP"};